import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEqual } from 'lodash';

const passwordStrength = {
	0 : 'weak',
	1 : 'okay',
	2 : 'good',
	3 : 'strong',
	4 : 'stronger',
	5 : 'too short',
};

class PasswordStrengthIndicator extends Component {
	/* Displays password strength depending upon the score given */

	shouldComponentUpdate = ({ passwordScore }) => {
		const lastProps = this.props;
		return !isEqual(passwordScore, lastProps.passwordScore);
	};

	render() {
		const { passwordScore, outerClassName } = this.props;
		return (
			<div>
				<div className={`padding-bottom-5 password-strength-background ${outerClassName}`}>
					<span className={`password-strength-indicator password-strength-indicator-${passwordScore}`} />
				</div>
				<span className="font-size-12">
					Password strength:
					{ passwordStrength[passwordScore] }
				</span>
			</div>
		);
	}
}

PasswordStrengthIndicator.propTypes = {
	passwordScore  : PropTypes.number,
	outerClassName : PropTypes.string,
};

PasswordStrengthIndicator.defaultProps = {
	passwordScore  : 5,
	outerClassName : '',
};

export default PasswordStrengthIndicator;
